import getWindowSize from "../utils/windowSize";

function updateWindowSize() {
    return {
        type: "WINDOW_SIZE_CHANGE",
        payload: getWindowSize()
    };
}

export function dispatchUpdateWindowSize() {
    return (dispatch, getState) => {
        return dispatch(updateWindowSize());
    };
}
